import { core } from '../core/index.js';
import { filterFabricErrors } from '../errors/errors.js';
/**
 * 获取系统扩展信息。
 */
export type FabricGetSystemInfoExtendCallbackData = {
  /**
   * APP数量
   * @example ''
   */
  appAmt: string;
  /**
   * 是否充电
   */
  charging: boolean;
  /**
   * 系统是否已录入指纹
   */
  isEnrolledFingerPrints: boolean;

  /**
   * 系统是否已录入人脸
   */
  isEnrolledFacePrints: boolean;
  /**
   * 是否刷机
   */
  isRoot: boolean;
  /**
   * 是否支持人脸
   */
  isSupportFaceID: boolean;
  /**
   * 是否设置锁屏密码，1代表是
   */
  isKeyguardSecure: boolean;
  /**
   * 是否支持指纹解锁，1代表是
   */
  isSupportTouchID: boolean;
  /**
   * 系统时区
   * @example 'Asia/Shanghai (GMT+8) offset 28800'
   */
  systemTimezone: string;
  /**
   * 推送通知app内部开关 与 appNotifySwitch 相同
   */
  systemNotifySwitch: boolean;
  /**
   * 系统日期包含时间戳
   * @example 1637894302771
   */
  systemDate: string;
  /**
   * 支持视频分辨率范围
   * @example ['4032x3024', '192x144'];
   */
  videoResolutionRanges: string[];
  /**
   * 可自由使用存储容量，kb单位
   * @example 151594816
   */
  freeDiskSpace: string;
  /**
   * 短信内容权限
   */
  msgCompetence: boolean;
  /**
   * 全部存储空间容量，kb单位
   * @example 249880148
   */
  totalDiskSpace: string;
  /**
   * 国际移动用户识别码 经常变更随机值
   */
  imsi: string;
  /**
   * 电池状态，0-1值，1代表满电，0代表空电
   * @example '0.50'
   */
  soc: string;
  /**
   * 支持图片分辨率范围
   * @example ['4032x3024', '192x144']
   */
  photoResolutionRanges: string[];
  /**
   * 屏幕亮度 0 - 1
   * @example 0.76
   */
  screenBrightness: string;
  /**
   * 推送通知app内部开关
   */
  appNotifySwitch: boolean;

  /**
   * 可自由使用的运行内存容量，kb单位
   * @example 1246960
   */
  freeRAM: string;

  /**
   * sim卡卡号，标准20位，各家运营商逻辑略有不同，可查询归属地
   */
  iccid: string;
  /**
   * 风控要求参考旅行APP拼接的设备拓展信息，ios、android拼接规则不同
   * Android拼接规则："4^" + 系统版本 + ",5^" + 手机型号 + ",6^" + 网络类型
   * Ios拼接规则： "2^\(AppInfo.bundleIdentifier),4^\(DeviceInfo.getDeviceSystemVersion()),5^\(DeviceInfo.getDeviceCode())"
   * @example android: '4^13,5^PHM110,6^WIFI'
   * @example ios: '2^com.ly.wallet,4^16.2,5^iPhone14,2'
   */
  extend?: string;
};

/**
 * 获取系统扩展信息。
 */
export const getSystemInfoExtend = () => {
  const result = core.call<
    'fabric_utils.getSystemInfoExtend',
    FabricGetSystemInfoExtendCallbackData
  >('fabric_utils.getSystemInfoExtend');
  const fabricErrors = filterFabricErrors(
    result.code,
    result.message,
    result.data
  );
  if (fabricErrors) {
    throw fabricErrors;
  } else {
    return result.data;
  }
};
